import { html, rune, type Html, View } from 'rune-ts';
import klass from './LinksSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { staticTypoPcMo, typoPcMo } from '../../../../../shared/typography/typo';
import { ArrowRightIcon } from '../../../../components/atoms/Icon';

interface LinkCardProps {
  card_number: number;
}

export class LinkCard extends View<LinkCardProps> {
  override template({ card_number }: LinkCardProps): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const image_urls: Record<number, string> = {
      1: '//s3.marpple.co/files/u_4648126/2024/10/original/bc6b550ef38af82b841465f74428225b11587a4e1.png',
      2: '//s3.marpple.co/files/u_4648126/2024/10/original/530205c8c224d8f18e4365f3605c75008ccd0f101.png',
      4: '//s3.marpple.co/files/u_4648126/2024/10/original/969c7a36f1be0c1ce9f8178404caf9e86e8578631.png',
      5: '//s3.marpple.co/files/u_4648126/2024/10/original/5e40ffd2c282267a0b123a873910b088fc1c79b31.png',
    };
    const links: Record<number, string> = {
      1: 'https://marpple.shop/kr/@/products?cate_list_id=148&page=1',
      2: 'https://marpple.shop/kr/@/products?cate_list_id=188',
      3: 'https://marpple.shop/kr/@/youtube',
      4: 'https://marpple.shop/kr/@/products?cate_list_id=47',
      5: 'https://marpple.shop/kr/@/popupstore/online',
    };
    const yotube_marpple_img = is_mobile
      ? '//s3.marpple.co/files/u_4648126/2024/10/original/35a8879d2ad8d29d033a5a5ed4d97ed93050306b1.png'
      : '//s3.marpple.co/files/u_4648126/2024/10/original/06ff6d7c24f1afce1d193b1c0f3b1d088a93c2881.png';
    const texts = {
      title: html.preventEscape(ET(`mps2::landing::handmade::links_card_title_${card_number}`)),
      description: html.preventEscape(
        ET(`mps2::landing::handmade::${is_mobile ? 'mo_' : ''}links_card_description_${card_number}`),
      ),
      sub_description:
        is_mobile && card_number !== 4
          ? html.preventEscape(
              ET(
                `mps2::landing::handmade::${is_mobile ? 'mo_' : ''}links_card_sub_description_${card_number}`,
              ),
            )
          : '',
    };
    const images_size: Record<number, string> = {
      1: klass.size_sm,
      2: klass.size_md,
      4: klass.size_sm,
      5: klass.size_lg,
    };

    return html`
      <div class="${klass.link_card}">
        ${card_number === 3
          ? html` <div class="${klass.video_wrapper}">
              <img
                src="${getResizedUrl({
                  url: yotube_marpple_img,
                  width: 300 * 2,
                  quality: 85,
                  format: 'webp',
                })}"
                alt="마플샵 핸드메이드 링크 이미지"
              />
              <video
                preload="none"
                autoplay=""
                loop=""
                muted=""
                playsinline=""
                src="//s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2024/10/original/carpet_weaving.mp4"
              ></video>
            </div>`
          : html`<div class="${klass.image_wrapper} ${is_mobile ? '' : images_size[card_number]}">
              <img
                src="${getResizedUrl({
                  url: image_urls[card_number] || '',
                  width: 350 * 2,
                  quality: 85,
                  format: 'webp',
                })}"
                alt="마플샵 핸드메이드 링크 이미지"
              />
            </div> `}
        <div class="${klass.content_wrapper}">
          <div class="${klass.content}">
            <div class="${klass.title_wrapper}">
              <div
                class="${klass.number} ${staticTypoPcMo({
                  is_mobile,
                  pc: 'bebas_24_bold',
                  mo: 'bebas_16_bold',
                })}"
              >
                0${card_number}
              </div>
              <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '28_bold', mo: '20_bold' })}">
                ${texts.title}
              </div>
            </div>
            <div class="${klass.desc_wrapper}">
              <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_medium' })}">
                ${texts.description}
              </div>
              <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_medium' })}">
                ${texts.sub_description}
              </div>
            </div>
          </div>
          <a href="${links[card_number]}" target="_blank">
            <div class="${klass.link} ${typoPcMo({ is_mobile, pc: '16_bold', mo: '14_bold' })}">
              ${ET(`mps2::landing::handmade::links_cta_button_text_${card_number}`)}
              <div class="${klass.arrow_button}">${ArrowRightIcon}</div>
            </div>
          </a>
        </div>
      </div>
    `;
  }
}
